// Пересэмплинг растра при вставке под печатное разрешение.
//
// Физический размер слоя считается из DPI файла (см. image_dpi.js): мм = px / dpi * 25.4.
// Плоттер печатает в 150 DPI, всё что выше — байты, которые никто не увидит: они
// раздувают запрос сохранения, хранилище и память RIP. Масштаб 150/dpi оставляет
// физический размер слоя ТЕМ ЖЕ, срезая только избыточные пиксели.
//
// Цена: если потом сильно увеличить слой в редакторе, картинка станет мягче —
// запаса разрешения больше нет. Для вектора (SVG) пересэмплинг не применяется.

export const PRINT_DPI = 150

// Ниже этого выигрыша пере-кодирование не окупается (риск потерь без пользы).
const MIN_GAIN = 0.9

export function resampleScale(dpi, printDpi = PRINT_DPI) {
  if (!(dpi > 0)) return 1
  const scale = printDpi / dpi
  if (scale >= MIN_GAIN) return 1
  return scale
}

export function resampledSize(width, height, scale) {
  return {
    width: Math.max(1, Math.round(width * scale)),
    height: Math.max(1, Math.round(height * scale)),
  }
}
